import { render, staticRenderFns } from "./textArray.vue?vue&type=template&id=ae597c2e"
import script from "./textArray.vue?vue&type=script&lang=js"
export * from "./textArray.vue?vue&type=script&lang=js"
import style0 from "./textArray.vue?vue&type=style&index=0&id=ae597c2e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae597c2e')) {
      api.createRecord('ae597c2e', component.options)
    } else {
      api.reload('ae597c2e', component.options)
    }
    module.hot.accept("./textArray.vue?vue&type=template&id=ae597c2e", function () {
      api.rerender('ae597c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/textArray.vue"
export default component.exports